import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RoomsApi from '../generated/api/Rooms';

export default (service: Servicelayer) => ({
  ...RoomsApi(service),

  // Add custom calls here

});
